import baseApi from '@store/api/baseApi';

const blockSuggestionApiSlice = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getArtboardProductTag: builder.query({
			query: ({ productId }) => ({
				url: `/artwork-artboard/product/${productId}`,
				method: 'GET'
			})
		}),
		createArtboardProductTag: builder.mutation({
			query: ({ params }) => ({
				url: `/artwork-artboard/product/tag`,
				method: 'POST',
				params
			})
		}),
		updateArtboardProductTag: builder.mutation({
			query: ({ artworkArtboardId, params }) => ({
				url: `/artwork-artboard/${artworkArtboardId}/product`,
				method: 'PUT',
				params
			})
		}),
		deleteArtboardProductTag: builder.mutation({
			query: ({ artworkArtboardId, params }) => ({
				url: `/artwork-artboard/${artworkArtboardId}/product`,
				method: 'DELETE',
				params
			})
		})
	})
});

export const {
	useGetArtboardProductTagQuery,
	useCreateArtboardProductTagMutation,
	useUpdateArtboardProductTagMutation,
	useDeleteArtboardProductTagMutation
} = blockSuggestionApiSlice;
